/**
 * Helper per estrarre in modo sicuro il messaggio d'errore da una risposta axios.
 *
 * FastAPI 422 restituisce `detail` come **array** di oggetti
 * `[{type, loc, msg, input, url}, ...]` — se passato direttamente a `toast.error`
 * (che renderizza il valore come React child) si scatena il famigerato
 * "Objects are not valid as a React child".
 *
 * Questo helper restituisce sempre una stringa.
 */
export function apiErrMsg(err, fallback = "Errore") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length > 0) {
    const first = d[0];
    if (typeof first === "string") return first;
    if (first && typeof first === "object" && first.msg) return String(first.msg);
  }
  if (d && typeof d === "object" && d.msg) return String(d.msg);
  if (err?.message && typeof err.message === "string") return err.message;
  return fallback;
}
